import React from 'react';

const DefaultListItem = ({ content, style = {} }) => (
  <div className="message-list color-secondary" style={style}>
    {content}
  </div>
);

export default DefaultListItem;
